(()=>{
 'use strict';
 const product=window.FultonsSofaOptions?.['15887268086143'];
 const script=document.querySelector('script[src*="fultons-maxime-option-thumbnails.js"]');
 if(!product?.configurations?.length||!script?.src)return;

 // Maxime's selector uses one consistent set of supplier line drawings from
 // the July 2026 Duresta Maxime PDF. Product and lifestyle photographs remain
 // in the gallery, where differences in cover and camera angle are useful.
 const files={
  'Grand Classic Back Split Sofa':['fultons-maxime-grand-classic-schematic.png','Maxime Grand Classic Back Split Sofa — Duresta supplier schematic'],
  'Grand Scatter Back Split Sofa':['fultons-maxime-grand-scatter-schematic.png','Maxime Grand Scatter Back Split Sofa — Duresta supplier schematic'],
  'Large Classic Back Split Sofa':['fultons-maxime-large-classic-schematic.png','Maxime Large Classic Back Split Sofa — Duresta supplier schematic'],
  'Large Scatter Back Split Sofa':['fultons-maxime-large-scatter-schematic.png','Maxime Large Scatter Back Split Sofa — Duresta supplier schematic'],
  'Medium Classic Back Sofa':['fultons-maxime-medium-classic-schematic.png','Maxime Medium Classic Back Sofa — Duresta supplier schematic'],
  'Medium Scatter Back Sofa':['fultons-maxime-medium-scatter-schematic.png','Maxime Medium Scatter Back Sofa — Duresta supplier schematic']
 };
 for(const configuration of product.configurations){
  const entry=files[configuration.label];if(!entry)continue;
  configuration.pickerThumbnail=new URL(entry[0],script.src).href;
  configuration.pickerThumbnailAlt=entry[1];
  configuration.pickerThumbnailKind='supplier-schematic';
 }
})();
